import { isDefined } from "@clipboard-health/util-ts";
import { DialogContent } from "@mui/material";
import {
  BottomSheet,
  BottomSheetIllustrationContent,
  type UseModalState,
} from "@src/appV2/redesign/system/ui-components";
import { useCallback } from "react";

import { BottomSheetHeader } from "../../components/BottomSheetHeader";
import { Button } from "../../components/Button";
import { DialogFooter } from "../../components/DialogFooter";

interface DocumentSubmissionErrorBottomSheetProps {
  modalState: UseModalState;
  onClick?: () => void;
}

export function DocumentSubmissionErrorBottomSheet(props: DocumentSubmissionErrorBottomSheetProps) {
  const { modalState, onClick } = props;

  const handleClose = useCallback(() => {
    modalState.closeModal();
  }, [modalState]);

  return (
    <BottomSheet
      footer={
        <DialogFooter orientation="vertical">
          {isDefined(onClick) && (
            <Button fullWidth size="large" onClick={onClick}>
              Try again
            </Button>
          )}
        </DialogFooter>
      }
      header={<BottomSheetHeader onClose={handleClose} />}
      modalState={modalState}
      onClose={handleClose}
    >
      <DialogContent sx={{ paddingX: 5 }}>
        <BottomSheetIllustrationContent
          illustrationType="document-rejected"
          title="Something went wrong"
          description="An issue occurred while submitting your document. Please try again or wait a few minutes and try again later."
        />
      </DialogContent>
    </BottomSheet>
  );
}
